import React, { useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCompass, faRoute } from '@fortawesome/free-solid-svg-icons';

const Container = styled.div`
  position: fixed;
  bottom: 100px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 1000;

  @media (max-width: 768px) {
    bottom: 120px;
  }
`;

const Tab = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: ${props => props.active ? '#F38530' : 'rgba(255, 255, 255, 0.9)'};
  color: ${props => props.active ? '#fff' : '#14464F'};
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
    background: ${props => props.active ? '#F38530' : '#f5f5f5'};
  }

  @media (max-width: 768px) {
    padding: 10px 16px;
    font-size: 13px;
  }
`;

const Content = styled.div`
  position: fixed;
  bottom: 160px;
  right: 20px;
  width: 400px;
  max-height: 70vh;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow-y: auto;
  z-index: 999;
  
  @media (max-width: 768px) {
    bottom: 180px;
    width: calc(100% - 40px);
    right: 20px;
  }
`;

const FloatingTabs = ({ onTabChange, activeTab: externalActiveTab }) => {
  const [activeTab, setActiveTab] = useState(externalActiveTab || 'explored');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (onTabChange) {
      onTabChange(tab);
    }
  };

  return (
    <>
      <Container>
        <Tab
          active={activeTab === 'explored'}
          onClick={() => handleTabClick('explored')}
        >
          <FontAwesomeIcon icon={faCompass} />
          Explorer
        </Tab>
        <Tab
          active={activeTab === 'tours'}
          onClick={() => handleTabClick('tours')}
        >
          <FontAwesomeIcon icon={faRoute} />
          Tours
        </Tab>
      </Container>
      {activeTab && (
        <Content>
          {/* Content will be rendered by parent component based on activeTab */}
        </Content>
      )}
    </>
  );
};

export default FloatingTabs; 